var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubtrIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 5,
    fill: "#BBF7D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.334 32.0003H42.6673M33.334 24.0003C33.334 24.7367 32.737 25.3337 32.0007 25.3337C31.2643 25.3337 30.6673 24.7367 30.6673 24.0003C30.6673 23.2639 31.2643 22.667 32.0007 22.667C32.737 22.667 33.334 23.2639 33.334 24.0003ZM33.334 40.0003C33.334 40.7367 32.737 41.3337 32.0007 41.3337C31.2643 41.3337 30.6673 40.7367 30.6673 40.0003C30.6673 39.2639 31.2643 38.667 32.0007 38.667C32.737 38.667 33.334 39.2639 33.334 40.0003Z",
    stroke: "#9333EA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtrIcon);
export default __webpack_public_path__ + "static/media/Subtr_icon.e3ea6e5e81adbd91f6c135b8ba748da0.svg";
export { ForwardRef as ReactComponent };